import { fetchPortfolioProjectItems } from './fetch-portfolio-project-items';
import { fetchPortfolioProjects } from './fetch-portfolio-projects';
export const fetchPortfolio = async (httpClient, errorHandler, ids) => {
  const portfolioProjects = [];
  const projects = await fetchPortfolioProjects(httpClient, errorHandler, ids);
  const projectPromises = projects.filter(project => Boolean(project.id)).map(async project => {
    const items = await fetchPortfolioProjectItems(httpClient, errorHandler, project.id);
    return {
      items,
      project
    };
  });
  const results = await Promise.all(projectPromises);
  portfolioProjects.push(...results);
  return portfolioProjects;
};
//# sourceMappingURL=fetch-portfolio.js.map